<script lang="ts" setup>
import type { Component, Page } from '@bloomreach/spa-sdk'
import { toRefs } from 'vue'
/**
 * SDX
 */

interface TagItem {
    name: string
    url: string
}

const props = defineProps<{
    component: Component
    page: Page
}>()

const { component, page } = toRefs(props)

const data = computed(() => component.value.getModels())
const { showOtherLabel, currentTag, moreLabel, lessLabel, otherTags } = data.value

data.value.otherTags = otherTags.sort((a: TagItem, b: TagItem) => a.name.localeCompare(b.name))
</script>

<template>
    <article class="page-plus mt-12 lg:mt-16">
        <header class="mx-auto my-12 mb-6 px-4 text-center lg:my-16">
            <h1
                class="mb-2 text-2md font-bold md:text-4xl lg:text-5xl"
                v-html="currentTag?.name"
            />
        </header>
        <section class="mx-auto mb-12 max-w-6.5xl px-3 lg:px-0">
            <p
                class="mb-4 text-xs md:mb-6 md:text-base"
                v-html="showOtherLabel"
            />
            <PlusBlogTagList
                :data="otherTags"
                :toggle-copy="{ more: moreLabel, less: lessLabel }"
            />
        </section>
    </article>
</template>
